// Must run before React renders anything — guards the DOM against Google
// Translate mutations that otherwise crash the whole app (see domPatches.js).
import './utils/domPatches'

import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { ErrorBoundary } from './utils/bugsnag'
import ErrorFallback from './components/ErrorFallback'
import { versionCheckService } from './services/versionCheck'
import { captureAttribution } from './utils/attribution'

// Campaign parameters (utm_*, fbclid) disappear after the first navigation, so
// they are read before the router runs. First touch only; never throws.
try {
  captureAttribution()
} catch {
  // attribution is best effort
}

// Start version checking service
versionCheckService.start();

const root = createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
)
